import * as React from 'react';
import { compose, setDisplayName } from 'recompose';
import { connect } from 'react-redux';
import { LayoutSize, CellIndex } from 'types';
import { State } from 'reducers';
import { getLayout } from 'selectors/monitoringSelectors';
import { MonitoringCell } from './MonitoringCell';
import { times } from 'util/times';

import './MonitoringLayout.css';

export const RawMonitoringLayout = ({ size }: StateProps) =>
    <div id="monitoring-layout" className={ `grid${size}` }>
        { times(size, i =>
            <MonitoringCell
                key={ i.toString() }
                cellIndex={ i + 1 as CellIndex }
            />
        ) }
    </div>
;

type StateProps = {
    size: LayoutSize;
};

const mapStateToProps = (state: State): StateProps => ({
    size: getLayout(state),
});

export const MonitoringLayout = compose<StateProps, {}>(
    setDisplayName('MonitoringLayout'),
    connect(mapStateToProps),
)(RawMonitoringLayout);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/mainPanel/MonitoringLayout.tsx